export default {
  inviteFriends: "Invite Friends",
  recieveReward:
    "Give the invitation code or link to your friends and get rewards together.",
  guidAndRules: "Invitation Guidelines and Rules",
  inviteLink: "Invite Link",
  todayRewardValue: "Today's Reward Value",
  sumOfInvited: "Total Invited",
  invitedList: "Invited List",
  filters: "Filters",
  for: "For",
  invitationCodeCopied: "Invitation code copied.",
  invitationLinkCopied: "Invitation link copied.",
  inviteCode: "Invite code",
  noInviteMsg: "You have not invited anyone."
};
